import React from 'react';
import { Lock, Zap } from 'lucide-react';
import { Link } from 'react-router-dom';

const FeatureGuard = ({ user, feature, children, fallback }) => {
    // If no user or user doesn't have the feature enabled (and is not admin)
    // Admins usually bypass, but let's respect the flag or make admin bypass explicit if needed.
    // For now, let's assume even admins need the flag OR we can say admins always have access.
    // Let's stick to the flag for granularity, but default admin flags to true in DB.

    // Admin Bypass: Admins always have access
    const hasAccess = ['admin', 'super_admin'].includes(user?.role) || (user?.features && user?.features[feature] !== false);

    if (hasAccess) {
        return <>{children}</>;
    }

    if (fallback) {
        return <>{fallback}</>;
    }

    return (
        <div className="flex flex-col items-center justify-center min-h-[400px] p-8 text-center bg-white dark:bg-slate-900 rounded-2xl border-2 border-dashed border-slate-300 dark:border-slate-800">
            <div className="w-16 h-16 bg-slate-100 dark:bg-slate-800 rounded-2xl flex items-center justify-center mb-6">
                <Lock className="text-slate-700 dark:text-slate-400" size={32} />
            </div>
            <h3 className="text-2xl font-bold text-slate-900 dark:text-white mb-2">
                Feature Locked
            </h3>
            <p className="text-slate-600 dark:text-slate-400 dark:text-slate-400 max-w-md mb-8">
                This feature is currently not available for your account.
                Please upgrade your plan or contact your administrator to unlock it.
            </p>
            <div className="flex gap-4">
                <button
                    onClick={async () => {
                        try {
                            const res = await fetch('http://localhost:3001/api/payment/create-checkout-session', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': `Bearer ${localStorage.getItem('token')}` // If needed
                                },
                                body: JSON.stringify({ userId: user._id })
                            });
                            const data = await res.json();
                            if (data.url) window.location.href = data.url;
                        } catch (err) {
                            console.error('Upgrade Failed', err);
                            alert('Upgrade service temporary unavailable');
                        }
                    }}
                    className="flex items-center gap-2 px-6 py-3 bg-emerald-500 hover:bg-emerald-600 text-slate-900 dark:text-white font-semibold rounded-xl transition-all shadow-lg shadow-emerald-500/20"
                >
                    <Zap size={18} />
                    Upgrade Plan
                </button>
                <Link
                    to="/contact"
                    className="px-6 py-3 bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-700 text-slate-700 dark:text-slate-300 font-semibold rounded-xl hover:bg-slate-50 dark:hover:bg-slate-700 transition-all"
                >
                    Contact Support
                </Link>
            </div>
        </div>
    );
};

export default FeatureGuard;
